/**
 * Load Google base premium functions
 */

(function (wpm, $, undefined) {


}(window.wpm = window.wpm || {}, jQuery))
